import React, { useState, useEffect, useRef, useMemo } from "react";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import useAuth from "../../composant_reutilisable/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import axios from 'axios';
import Pas_acces from "../../composant_reutilisable/pas_acces";
import { Accordion } from "react-bootstrap";

import {
    FaSortAmountUp,
    FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaSearch,
    FaCheckCircle,
    FaBoxes,
    FaQuestionCircle,
} from "react-icons/fa";

const Factures = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const user_id = localStorage.getItem("userId");
    const navigate = useNavigate();
    const { parcRef } = location.state || {};

    // État pour les données et la gestion de la table
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [alertModal, setAlertModal] = useState({ message: "", type: "" });
    // const [totalItems, setTotalItems] = useState(0);
    const [showInfo, setShowInfo] = useState(true);
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];

    const [userData, setUserData] = useState({});

    const fetchUserData = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            setUserData(data);
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        fetchUserData();
    }, [user_id]);

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        // setTimeout(() => {
        //   setAlert({ message: "", type: "" });
        // }, 3000);
    };

    const showAlertModal = (message, type = "success") => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: "", type: "" });
        setAlertModal({ message: "", type: "" });
    };

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Factures GIE";
        }
    }, [user_id]);


    const [factures, setFactures] = useState([]);

    useEffect(() => {
        const fetchFactures = async () => {
            if (!parcRef) {
                showAlert("Le parc n'est pas défini.", "danger");
                return;
            }

            try {
                setLoading(true);

                const token = localStorage.getItem('access_token');

                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/api/liste-factures/${parcRef}/`,
                    {
                        method: "GET",   // ou "POST" SI TON API L'EXIGE
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`,
                        }
                    }
                );

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Erreur ${response.status}: ${errorText}`);
                }

                const data = await response.json();

                // Cas 1 : le backend retourne { factures: [...] }
                if (data.factures) {
                    setFactures(data.factures);
                }
                // Cas 2 : le backend retourne un tableau
                else if (Array.isArray(data)) {
                    setFactures(data);
                }
                else {
                    setFactures([]);
                    showAlert("Format de réponse inattendu.", "warning");
                }

            } catch (error) {
                console.error("Erreur lors du chargement des factures :", error);
                setFactures([]);
                showAlert(error.message, "danger");
            } finally {
                setLoading(false);
            }
        };

        fetchFactures();
    }, [parcRef]);


    // const facturesMock = [
    //     {
    //         id: 1,
    //         reference: "FA001",
    //         reference_lv: "LVI00000084",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG9949AQ", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 2,
    //         reference: "FA002",
    //         reference_lv: "LV-2024-00123",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG6755BM", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 3,
    //         reference: "FA003",
    //         reference_lv: "LV-2024-00124",
    //         montant_total: "2000000.00",
    //         montant_minimum_avance: "400000.00",
    //         date_creation: "2024-02-01T11:00:00+00:00",
    //         statut: "partiellement_paye",
    //         nombre_lignes: 1,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "15.00", montant_unitaire: "200000.00", montant_minimum_unitaire: "40000.00" }
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Niger", immatriculation: "TN1234AB", nationalite: "Niger" }
    //         ]
    //     },
    //     {
    //         id: 4,
    //         reference: "FA001",
    //         reference_lv: "LVI00000084",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG9949AQ", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 5,
    //         reference: "FA002",
    //         reference_lv: "LV-2024-00123",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG6755BM", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 6,
    //         reference: "FA003",
    //         reference_lv: "LV-2024-00124",
    //         montant_total: "2000000.00",
    //         montant_minimum_avance: "400000.00",
    //         date_creation: "2024-02-01T11:00:00+00:00",
    //         statut: "partiellement_paye",
    //         nombre_lignes: 1,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "15.00", montant_unitaire: "200000.00", montant_minimum_unitaire: "40000.00" }
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Niger", immatriculation: "TN1234AB", nationalite: "Niger" }
    //         ]
    //     },
    //     {
    //         id: 7,
    //         reference: "FA001",
    //         reference_lv: "LVI00000084",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG9949AQ", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 8,
    //         reference: "FA002",
    //         reference_lv: "LV-2024-00123",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG6755BM", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 9,
    //         reference: "FA003",
    //         reference_lv: "LV-2024-00124",
    //         montant_total: "2000000.00",
    //         montant_minimum_avance: "400000.00",
    //         date_creation: "2024-02-01T11:00:00+00:00",
    //         statut: "partiellement_paye",
    //         nombre_lignes: 1,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "15.00", montant_unitaire: "200000.00", montant_minimum_unitaire: "40000.00" }
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Niger", immatriculation: "TN1234AB", nationalite: "Niger" }
    //         ]
    //     },
    //     {
    //         id: 10,
    //         reference: "FA001",
    //         reference_lv: "LVI00000084",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG9949AQ", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 11,
    //         reference: "FA002",
    //         reference_lv: "LV-2024-00123",
    //         montant_total: "1500000.00",
    //         montant_minimum_avance: "300000.00",
    //         date_creation: "2024-01-15T10:30:00+00:00",
    //         statut: "en_attente",
    //         nombre_lignes: 2,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "10.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //             { numero_ligne: 2, quantite: "12.00", montant_unitaire: "150000.00", montant_minimum_unitaire: "30000.00" },
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Burkina", immatriculation: "TG6755BM", nationalite: "Togo" }
    //         ]
    //     },
    //     {
    //         id: 12,
    //         reference: "FA003",
    //         reference_lv: "LV-2024-00124",
    //         montant_total: "2000000.00",
    //         montant_minimum_avance: "400000.00",
    //         date_creation: "2024-02-01T11:00:00+00:00",
    //         statut: "partiellement_paye",
    //         nombre_lignes: 1,
    //         lignes: [
    //             { numero_ligne: 1, quantite: "15.00", montant_unitaire: "200000.00", montant_minimum_unitaire: "40000.00" }
    //         ],
    //         proprietaires: [
    //             { proprietaire: "CDT Niger", immatriculation: "TN1234AB", nationalite: "Niger" }
    //         ]
    //     },
    // ];

    // const [factures, setFactures] = useState(facturesMock);


    useEffect(() => {
        setLoading(false);
    }, []);


    const [parcs, setParcs] = useState([]);
    // Récupération des parcs
    const fetchParcs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                setParcs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };


    useEffect(() => {
        // fetchData();
        fetchParcs();
    }, [currentPage, itemsPerPage]);

    // Fonction de tri
    // const handleSearch = (e) => {
    //     setSearchTerm(e.target.value);
    //     setCurrentPage(1);
    //     fetchData(true);
    // };



    // const facturesFiltres = factures.filter((facture) => {
    //     if (!facture) return false; // Ajoutez cette vérification

    //     const search = searchTerm.toLowerCase();

    //     // Vérifie si au moins un propriétaire correspond
    //     const matchProprietaire = facture.proprietaires &&
    //         Array.isArray(facture.proprietaires) &&
    //         facture.proprietaires.some(p =>
    //             p && p.proprietaire && p.proprietaire.toLowerCase().includes(search)
    //         );

    //     // Vérifie le reste des champs avec des vérifications de sécurité
    //     const matchOther =
    //         (facture.reference || "").toLowerCase().includes(search) ||
    //         (facture.statut || "").toLowerCase().includes(search) ||
    //         (facture.montant_total || "").toString().includes(search) ||
    //         (facture.montant_minimum_avance || "").toString().includes(search) ||
    //         (facture.date_creation || "").includes(search);

    //     return matchProprietaire || matchOther;
    // });

    const [currentFilter, setCurrentFilter] = useState("");

    const handleFilterClick = (statut) => {
        setCurrentFilter(statut);
        setCurrentPage(1); // Réinitialiser à la première page lors du changement de filtre
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [currentFilter, searchTerm, itemsPerPage]);



    const facturesFiltres = factures.filter((facture) => {
        if (!facture) return false;

        const search = searchTerm.toLowerCase();

        // 🔹 filtre statut
        const matchStatut =
            !currentFilter || facture.statut === currentFilter;

        // 🔹 filtre recherche texte
        const matchProprietaire = facture.proprietaires?.some(p =>
            p?.proprietaire?.toLowerCase().includes(search)
        );

        const matchOther =
            (facture.reference || "").toLowerCase().includes(search) ||
            (facture.statut || "").toLowerCase().includes(search) ||
            (facture.montant_total || "").toString().includes(search) ||
            (facture.montant_minimum_avance || "").toString().includes(search) ||
            (facture.date_creation || "").includes(search);

        // 👉 statut ET (search)
        return matchStatut && (matchProprietaire || matchOther);
    });


    const totalItems = facturesFiltres.length;




    // const handleSort = (key) => {
    //     setSortConfig(prev => ({
    //         key,
    //         direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    //     }));
    // };

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };


    const getSortValue = (facture, key) => {
        switch (key) {
            case 'transporteur':
                return facture.proprietaires?.[0]?.proprietaire || '';

            default:
                return facture[key] ?? '';
        }
    };


    const facturesTries = [...facturesFiltres].sort((a, b) => {
        if (!sortConfig.key) return 0;

        let valueA = getSortValue(a, sortConfig.key);
        let valueB = getSortValue(b, sortConfig.key);

        // Nombres
        if (!isNaN(valueA) && !isNaN(valueB)) {
            return sortConfig.direction === 'asc'
                ? Number(valueA) - Number(valueB)
                : Number(valueB) - Number(valueA);
        }

        // Dates
        if (sortConfig.key === 'date_creation') {
            return sortConfig.direction === 'asc'
                ? new Date(valueA) - new Date(valueB)
                : new Date(valueB) - new Date(valueA);
        }

        // Texte
        return sortConfig.direction === 'asc'
            ? valueA.toString().localeCompare(valueB.toString(), 'fr', { sensitivity: 'base' })
            : valueB.toString().localeCompare(valueA.toString(), 'fr', { sensitivity: 'base' });
    });

    // const renderSortIcon = (key) => {
    //     if (sortConfig.key !== key) return null;

    //     return sortConfig.direction === 'asc'
    //         ? <FaSortAmountUp className="ml-1" />
    //         : <FaSortAmountDown className="ml-1" />;
    // };



    // Gestion du changement d'éléments par page
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = facturesTries.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(facturesFiltres.length / itemsPerPage);

    // Changer de page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Formater la date pour l'affichage
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('fr-FR', options);
    };


    const [showPaiementModal, setShowPaiementModal] = useState(false);
    const [selectedFacturePaiement, setSelectedFacturePaiement] = useState(null);
    const [fichierPaiement, setFichierPaiement] = useState([]);
    const [fileError, setFileError] = useState("");
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 Mo
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];

    const handleShowPaiement = (facture) => {
        setSelectedFacturePaiement(facture);
        setFichierPaiement(null);
        setFileError("");
        setShowPaiementModal(true);
    };

    const handleClosePaiement = () => {
        setSelectedFacturePaiement(null);
        setFichierPaiement(null);
        setFileError("");
        setShowPaiementModal(false);
    };

    const handleFileChange = (e) => {
        // const file = e.target.files[0];
        const files = Array.from(e.target.files);

        // if (!file) {
        //     setFileError("Veuillez sélectionner un fichier.");
        //     setFichierPaiement(null);
        //     return;
        // }
        if (!files.length) {
            setFileError("Veuillez sélectionner au moins un fichier.");
            setFichierPaiement([]);
            return;
        }

        // // Vérifier type
        // if (!allowedTypes.includes(file.type)) {
        //     setFileError("Format non valide. Formats acceptés : JPG, PNG, PDF.");
        //     setFichierPaiement(null);
        //     return;
        // }

        // // Vérifier taille du fichier
        // if (file.size > MAX_FILE_SIZE) {
        //     setFileError("Le fichier est trop volumineux (max 5 Mo).");
        //     setFichierPaiement(null);
        //     return;
        // }

        for (let file of files) {
            if (!allowedTypes.includes(file.type)) {
                setFileError("Format non valide. Formats acceptés : JPG, PNG, PDF.");
                setFichierPaiement([]);
                return;
            }

            if (file.size > MAX_FILE_SIZE) {
                setFileError("Un fichier dépasse la taille maximale autorisée (5 Mo).");
                setFichierPaiement([]);
                return;
            }
        }

        // Si tout va bien
        setFileError("");
        setFichierPaiement(files);
    };



    const [openDropdownId, setOpenDropdownId] = useState(null);
    const dropdownRef = useRef(null);

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownItemStyle = {
        padding: '8px 12px',
        width: '100%',
        textAlign: 'left',
        border: 'none',
        background: 'none',
        fontSize: '14px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    };

    const [showFactureModal, setShowFactureModal] = useState(false);
    const [selectedFacture, setSelectedFacture] = useState(null);

    const handleShowFacture = (facture) => {
        setSelectedFacture(facture);
        setShowFactureModal(true);
    };

    const handleCloseFacture = () => {
        setSelectedFacture(null);
        setShowFactureModal(false);
    };

    const formatStatut = (statut) => {
        switch (statut) {
            case "en_attente":
                return "En attente";
            case "partiellement_paye":
                return "Partiellement payé";
            case "totalement_paye":
                return "Totalement payé";
            case "soldee":
                return "Soldée";
            default:
                return statut;
        }
    };

    const getBadgeClass = (statut) => {
        switch (statut) {
            case "en_attente":
                return "badge badge-secondary p-2";
            case "partiellement_paye":
                return "badge badge-success  p-2";
            case "totalement_paye":
                return "badge badge-primary p-2";
            case "soldee":
                return "badge badge-primary p-2";
            default:
                return "badge badge-light";
        }
    };


    const [confirmationPaiementLoading, setConfirmationPaiementLoading] = useState(false);

    const handleConfirmPaiement = async () => {
        // Vérifier si fichier manquant
        if (!fichierPaiement) {
            setFileError("Veuillez sélectionner au moins un fichier avant de confirmer.");
            return;
        }
        setConfirmationPaiementLoading(true)

        try {

            const token = localStorage.getItem('access_token'); // Utilisez votre fonction getAuthToken
            const formData = new FormData();
            formData.append("reference_facture", selectedFacturePaiement.reference);
            // formData.append("fichier", fichierPaiement);
            fichierPaiement.forEach(file => {
                formData.append("fichiers", file); // ⚠️ même clé
            });

            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/api/confirmer-paiement/`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`, // Ajoutez l'authentification
                    },
                    body: formData // Notez que nous n'ajoutons pas Content-Type pour FormData
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Erreur lors de la confirmation du paiement");
            }

            if (data.success) {
                // Afficher message de succès
                showAlert(
                    `<strong>✅ Paiement confirmé avec succès !</strong><br>
                Facture <strong>${data.facture.reference}</strong> marquée comme soldée.<br>
                Statut : ${data.facture.statut_display}`,
                    "success"
                );

                // Mettre à jour l'état local de la facture
                setFactures(prevFactures =>
                    prevFactures.map(f =>
                        f.id === selectedFacturePaiement.id
                            ? {
                                ...f,
                                statut: 'soldee',
                                justificatif_paiement: data.facture.justificatif_url
                            }
                            : f
                    )
                );

                handleClosePaiement();
            } else {
                throw new Error(data.error || "Erreur lors de la confirmation");
            }

        } catch (error) {
            console.error("Erreur de paiement:", error);
            setFileError(error.message || "Erreur lors de l'enregistrement. Veuillez réessayer.");
        } finally {
            setConfirmationPaiementLoading(false)
        }
    };


    const [showGlossary, setShowGlossary] = useState(false);


    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Fret")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaBoxes size={25} className="mr-2" />
                                    Factures  sur {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>


                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            {/* <div className={`info-box p-0 col-lg-6 ${showInfo ? "open" : ""}`}>
                                <small>
                                <table className="table table-bordered text-center">
                                    <thead>
                                    <tr>
                                        <th><span className="badge badge-secondary">En attente réservation</span></th>
                                        <th><span className="badge badge-warning">En attente assignation</span></th>
                                        <th><span className="badge bg-success">Assignation en cours</span></th>
                                        <th><span className="badge bg-primary">Assignation terminée</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Le fret est déclaré mais pas encore réservé.</td>
                                        <td>Réservation effectuée, en attente d'assignation des camions.</td>
                                        <td>Certains camions sont assignés, mais pas tous.</td>
                                        <td>Tous les camions nécessaires ont été assignés.</td>
                                    </tr>
                                    </tbody>
                                </table>

                                </small>
                            </div> */}
                            {/* <small>Liste des déclarations de fret.</small> */}

                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>

                                    {parcRef && (
                                        <li className="breadcrumb-item custom-breadcrumb-item active">
                                            <Link to={`/Parcs-GIE`}>Groupement d'Intérêt Economique</Link>
                                        </li>
                                    )}
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Factures sur {parcs.find(p => p.ref_parc === userData?.parc)?.nom_parc || parcs.find(p => p.ref_parc === parcRef)?.nom_parc || '....'}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2`}>
                            <div
                                // Utilisation de dangerouslySetInnerHTML pour afficher le message HTML
                                dangerouslySetInnerHTML={{ __html: alert.message }}
                            />

                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',   // Ajustez l'espacement comme vous le souhaitez
                                    right: '10px', // Ajustez l'espacement comme vous le souhaitez
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des Factures</h5>
                            <div className="d-flex flex-column flex-md-row">


                            </div>
                        </div>
                        <div className="ibox-content">

                            {/* Barre de recherche et sélection d'éléments par page */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="me-2">
                                    <select
                                        value={itemsPerPage}
                                        onChange={handleItemsPerPageChange}
                                        className="form-select bg-default p-1"
                                        style={{
                                            width: "auto",
                                            border: "1px black solid",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                    <select
                                        style={{ border: '1px black solid', borderRadius: '5px' }}
                                        onChange={(e) => handleFilterClick(e.target.value)}
                                        className="form-select bg-default p-1 ml-2"
                                        value={currentFilter}
                                    >
                                        <option className="text-left" value="">Tout</option>
                                        <option className="text-left" value="en_attente">En attente</option>
                                        <option className="text-left" value="partiellement_paye">Partiellement payé</option>
                                        <option className="text-left" value="totalement_paye">Totalement payé</option>
                                        {/* <option className="text-left" value="expiree">Expirée</option> */}
                                    </select>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Rechercher..."
                                    className="form-control"
                                    style={{ maxWidth: "150px", width: "100%" }}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            {/* Tableauuuuuuuuuuuuuuuuuuuuuuuuuuuuuu */}
                            <div className="">
                                <table
                                    className="footable table table-stripped footable-loaded tablet breakpoint"
                                    data-page-size={itemsPerPage}
                                >
                                    <thead>
                                        <tr>
                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort('date_creation')}>
                                                Date de facture
                                                {sortConfig.key === 'date_creation'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('reference')}>
                                                Référence facture
                                                {sortConfig.key === 'reference'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('montant_total')}>
                                                Montant total
                                                {sortConfig.key === 'montant_total'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('montant_minimum_avance')}>
                                                Avance perçue
                                                {sortConfig.key === 'montant_minimum_avance'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('transporteur')}>
                                                Transporteur
                                                {sortConfig.key === 'transporteur'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort('statut')}>
                                                Statut
                                                {sortConfig.key === 'statut'}{sortConfig.direction === 'asc' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                            </th>

                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading && currentPage === 1 ? (
                                            <tr>
                                                <td colSpan="10" className="text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden"></span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : currentItems.length > 0 ? (
                                            currentItems.map((facture) => (
                                                <tr key={facture?.id}>
                                                    <td className="text-justify">
                                                        {new Date(facture.date_creation).toLocaleDateString()}
                                                    </td>
                                                    <td className="d-none d-md-table-cell text-center">
                                                        {facture?.reference}
                                                    </td>
                                                    <td className="d-none d-md-table-cell text-center">
                                                        {facture?.montant_total}
                                                    </td>
                                                    <td className="d-none d-md-table-cell text-center">
                                                        {facture?.montant_minimum_avance}
                                                    </td>

                                                    <td className="d-none d-md-table-cell text-center">
                                                        {facture?.proprietaires && facture.proprietaires.length > 0
                                                            ? facture.proprietaires[0].proprietaire
                                                            : 'Non spécifié'}
                                                    </td>

                                                    <td className="d-none d-md-table-cell text-center">
                                                        <span className={getBadgeClass(facture?.statut)}>
                                                            {formatStatut(facture?.statut)}
                                                        </span>
                                                    </td>

                                                    <td className="text-center">
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="light" id={`dropdown-fret-${facture.id}`} className="p-0 pr-1 pl-1">
                                                                <i className="fa fa-ellipsis-v text-dark"></i>
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu className="p-1">


                                                                {/* Option Détails - toujours visible */}
                                                                <Dropdown.Item
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleShowFacture(facture); // Utilise les données de factures
                                                                    }}
                                                                    className="d-flex align-items-center"
                                                                >
                                                                    <FaSearch className="mr-2 text-info" />
                                                                    Détails
                                                                </Dropdown.Item>

                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                <Dropdown.Item
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleShowPaiement(facture); // Utilise la facture sélectionnée
                                                                    }}
                                                                    className="d-flex align-items-center"
                                                                >
                                                                    <FaCheckCircle className="mr-2 text-success" />
                                                                    Confirmer paiement
                                                                </Dropdown.Item>



                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="11" className="text-center text-muted">
                                                    Aucune facture à afficher
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="dataTables_info" role="status" aria-live="polite">
                                        {loading ? (
                                            "Chargement..."
                                        ) : facturesFiltres.length === 0 ? (
                                            "Aucun élément à afficher"
                                        ) : (
                                            `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)
                                            } sur ${totalItems}`
                                            //   `Élément ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, fretsFiltres.length)} 
                                            // sur ${fretsFiltres.length}`
                                        )}
                                    </div>

                                    {totalItems > itemsPerPage && (
                                        <div>
                                            <button
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                                className="btn btn-light mx-1"
                                            >
                                                <FaArrowLeft />
                                            </button>

                                            {Array.from(
                                                { length: Math.ceil(totalItems / itemsPerPage) },
                                                (_, i) => i + 1
                                            )
                                                .filter(page =>
                                                    page === 1 ||
                                                    page === Math.ceil(totalItems / itemsPerPage) ||
                                                    Math.abs(page - currentPage) <= 2
                                                )
                                                .map((page, i, array) => (
                                                    <React.Fragment key={page}>
                                                        <button
                                                            onClick={() => setCurrentPage(page)}
                                                            className={`btn ${currentPage === page ? "btn-default" : "btn-light"
                                                                } mx-1`}
                                                        >
                                                            {page}
                                                        </button>
                                                        {array[i + 1] > page + 1 && <span className="mx-1">...</span>}
                                                    </React.Fragment>
                                                ))}

                                            <button
                                                onClick={() => setCurrentPage(prev => prev + 1)}
                                                disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
                                                className="btn btn-light mx-1"
                                            >
                                                <FaArrowRight />
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Modal de détails de factures */}
                <Modal show={showFactureModal} size="lg" centered onHide={handleCloseFacture}>
                    <Modal.Header className="border-bottom">
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">FACTURE</h5>
                            <span className="text-muted">
                                Réf : <strong>{selectedFacture?.reference}</strong>
                            </span>
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        {selectedFacture ? (
                            <div className="p-3" style={{ fontSize: '14px' }}>

                                {/* INFOS PRINCIPALES */}
                                <div className="row mb-4">
                                    <div className="col-md-7">
                                        <p><strong>Date :</strong> {new Date(selectedFacture.date_creation).toLocaleDateString()}</p>
                                        <p><strong>Réf. facture :</strong> {selectedFacture.reference}</p>
                                        <p><strong>Réf. lettre de voiture :</strong> {selectedFacture.reference_lv}</p>
                                    </div>

                                    <div className="col-md-5 text-md-end">
                                        <p className="mb-3"><strong className="mr-1">Statut :</strong>
                                            <span className={getBadgeClass(selectedFacture.statut)}>
                                                {formatStatut(selectedFacture.statut)}
                                            </span>
                                        </p>
                                        <p className="mb-3"><strong>Montant total : </strong>
                                            <span>{Number(selectedFacture.montant_total).toLocaleString()} FCFA</span>
                                        </p>
                                        <p className="mb-3"><strong>Avance perçue : </strong>
                                            <span>{Number(selectedFacture.montant_minimum_avance).toLocaleString()} FCFA</span>
                                        </p>
                                    </div>
                                </div>

                                {selectedFacture.proprietaires?.length > 0 && (
                                    <div className="border rounded p-3 mb-4 bg-light">
                                        <h6 className="border-bottom pb-2 mb-3">Transporteur</h6>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Nom :</strong> {selectedFacture.proprietaires[0].proprietaire}</p>
                                                <p><strong>Contact :</strong> {selectedFacture.proprietaires[0].numero_proprietaire}</p>
                                            </div>

                                            <div className="col-md-6">
                                                <p><strong>Immatriculation :</strong> {selectedFacture.proprietaires[0].immatriculation}</p>
                                                <p><strong>Carte transport :</strong> {selectedFacture.proprietaires[0].reference_carte_transport}</p>
                                                <p><strong>Nationalité :</strong> {selectedFacture.proprietaires[0].nationalite}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedFacture.lignes?.length > 0 && (
                                    <table className="table table-sm table-bordered">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Quantité</th>
                                                <th className="text-end">PU</th>
                                                <th className="text-end">Minimum</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedFacture.lignes.map(ligne => (
                                                <tr key={ligne.numero_ligne}>
                                                    <td>{ligne.numero_ligne}</td>
                                                    <td>{ligne.quantite}</td>
                                                    <td className="text-end">
                                                        {Number(ligne.montant_unitaire).toLocaleString()} FCFA
                                                    </td>
                                                    <td className="text-end">
                                                        {Number(ligne.montant_minimum_unitaire).toLocaleString()} FCFA
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}

                            </div>
                        ) : (
                            <p>Aucune facture sélectionnée</p>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseFacture}>Fermer</Button>
                    </Modal.Footer>
                </Modal>



                {/* Modal de confirmation de paiement */}
                <Modal show={showPaiementModal} centered onHide={handleClosePaiement}>
                    <Modal.Header >
                        <Modal.Title>
                            Confirmer le paiement – {selectedFacturePaiement?.reference}
                        </Modal.Title>
                    </Modal.Header>

                    {fileError && (
                        <div className="alert alert-danger py-2">
                            {fileError}
                        </div>
                    )}

                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Importer un ou plusieurs justificatifs (Photo ou PDF)</Form.Label>
                                <Form.Control
                                    type="file"
                                    multiple
                                    onChange={handleFileChange}
                                    accept=".jpg,.jpeg,.png,.pdf"
                                />
                            </Form.Group>


                            {/* {fichierPaiement && !fileError && (
                                <div className="alert alert-success py-2">
                                    Fichier sélectionné : <strong>{fichierPaiement.name}</strong>
                                </div>
                            )} */}
                            {fichierPaiement?.length > 0 && !fileError && (
                                <div className="alert alert-success py-2">
                                    <strong>Fichiers sélectionnés :</strong>
                                    <ul className="mb-0">
                                        {fichierPaiement.map((file, index) => (
                                            <li key={index}>{file.name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClosePaiement}>
                            Annuler
                        </Button>

                        <Button
                            variant="success"
                            onClick={handleConfirmPaiement}
                            disabled={confirmationPaiementLoading}
                        >
                            {confirmationPaiementLoading ? 'Confirmation...' : 'Confirmer Paiement'}

                        </Button>
                    </Modal.Footer>
                </Modal>

                <div className="footer text-center">
                    <div>
                        <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer">ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer">INOVACT SARL</a>
                    </div>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Factures;